module.exports = __webpack_public_path__ + "static/media/lounge_ageas_1.daf21de5.jpg";